import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

@Injectable()
export class RoutingService {
    constructor(private router: Router) {
    }
    // Dashboard
    routeToDashboard()                 { this.route('dashboard'); }
    routeToCreateProject()             { this.goto(['report', 'create']); }
    routeToSaveReport()                { this.goto(['report', 'save']); }
    routeToReportSummary(id: number)   { this.goto(['report', 'summary', id.toString()]); }
    routeToReportSummaryError()        { this.goto(['report', 'summary', '0']); } //0 will never be present and will display error page
    routeToDownloadReport(id: number)  { this.goto(['download', id.toString()]); }
    routeToSettings()                  { this.route('settings'); }
    routeToHelp()                      { this.route('help'); }
    routeToEditorial()                 { this.route('editorial'); }
    routeToViewProject()               { this.route('project'); }
    routeToViewAllProjects()           { this.route('reports'); }
    routeToSaveProject()               { this.goto(['report', 'save']); }
    routeToAddProjectAdjustments()     { this.goto(['report', 'adjust']); }
    routeToUnauthorised()              { this.route('noaccess'); }
    routeToStatus()                    { this.goto(['report', 'status']); }
    routeToPrivacyNotice()             { this.route('privacynotice'); }

    private route(location: string) {
        this.goto([location]);
    }

    private goto(location: Array<string>) {
        this.router.navigate(location);
    }

    currentRoute = () => {
        return this.router.url;
    }
}



// WEBPACK FOOTER //
// ./src/app/routing/services/routing.service.ts